import React, { useEffect } from 'react';
import { Button, Input, Select, Form, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { setUserInfo } from '../../store/userSlice';
import { STORAGE_KEYS, getFromStorage } from '../../utils/storage';
import styles from './Home.module.css';
import { RootState } from '../../store';
import siteConfig from '../../config/site.json';
import bgPattern from '../../assets/images/bg-pattern.png';
import bgPatternWebp from '../../assets/images/bg-pattern.webp';

import QRCode from '../../components/QRCode';

const { Option } = Select;

const Home: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const userName = useAppSelector((state: RootState) => state.user.name);
  const highestScore = useAppSelector((state: RootState) => state.user.highestScore);

  useEffect(() => {
    const savedUserInfo = getFromStorage(STORAGE_KEYS.USER_INFO);
    if (savedUserInfo) {
      form.setFieldsValue(savedUserInfo);
      dispatch(setUserInfo(savedUserInfo));
    }
  }, [form, dispatch]);

  const handleStart = async () => {
    try {
      const values = await form.validateFields();
      dispatch(setUserInfo({
        name: values.name,
        school: siteConfig.features.schoolSelection ? values.school : '未选择'
      }));
      message.success('信息提交成功！');
      navigate('/quiz');
    } catch (error) {
      message.error('请填写完整信息！');
    }
  };

  
  const containerStyle = {
    '--bg-pattern': `url(${bgPattern})`,
    '--bg-pattern-webp': `url(${bgPatternWebp})`
  } as React.CSSProperties;

  if (userName) {
    return (
      <div className={styles.container} style={containerStyle}>
        <div className={styles.content}>
          <div className={styles.header}>
            <div className={styles.title}>
              <h1>{siteConfig.title.main}</h1>
              <h2>{siteConfig.title.sub1}</h2>
              <h2>{siteConfig.title.sub2}</h2>
            </div>
          </div>

          <div className={styles.mainContent}>
            <QRCode userName={userName} highestScore={highestScore} />
            
            <div className={styles.actions}>
              <Button 
                className={styles.startButton}
                onClick={() => navigate('/quiz')}
              >
                继续闯关
              </Button>

              <Button 
                className={styles.logoutButton}
                onClick={() => {
                  localStorage.clear();
                  window.location.reload();
                }}
              >
                重新登录
              </Button>
            </div>
          </div>

          <div className={styles.info}>
            <p>主办单位：{siteConfig.organization.host}</p>
            <p>活动时间：{siteConfig.organization.time}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container} style={containerStyle}>
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.title}>
            <h1>{siteConfig.title.main}</h1>
            <h2>{siteConfig.title.sub1}</h2>
            <h2>{siteConfig.title.sub2}</h2>
          </div>
        </div>

        <div className={styles.mainContent}>
          <QRCode />

          <Form 
            form={form}
            className={styles.form}
            layout="vertical"
          >
            <Form.Item
              name="name"
              rules={[{ required: true, message: '请输入姓名' }]}
            >
              <Input 
                placeholder="请输入姓名"
                className={styles.input}
              />
            </Form.Item>

            {siteConfig.features.schoolSelection && (
              <Form.Item
                name="school"
                rules={[{ required: true, message: '请选择学校' }]}
              >
                <Select
                  placeholder="请选择学校"
                  className={styles.select}
                  showSearch={false}
                  virtual={false}
                  options={siteConfig.schools.map(school => ({
                    value: school,
                    label: school
                  }))}
                />
              </Form.Item>
            )}

            <Button 
              className={styles.startButton}
              onClick={handleStart}
            >
              开始闯关
            </Button>
          </Form>
        </div>

        <div className={styles.info}>
          <p>主办单位：{siteConfig.organization.host}</p>
          <p>活动时间：{siteConfig.organization.time}</p>
        </div>
      </div>
    </div>
  );
};

export default Home; 